import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ILocalInfo } from '../SetSixLawsInfo/setSixLawsInfo'
interface selectedRectsI {
  techTags: string[]
  objTags: string[]
  rects: ILocalInfo[]
}
const initialState: selectedRectsI = {
  techTags: [],
  objTags: [],
  rects: []
}

export const setSelectedRectsSlice = createSlice({
  name: 'setSelectedRects',
  initialState,
  reducers: {
    setRects: (state, action: PayloadAction<ILocalInfo[]>) => {
      state.rects = action.payload
    },
    setTechTags: (state, action: PayloadAction<string[]>) => {
      state.techTags = action.payload
    },
    setObjTags: (state, action: PayloadAction<string[]>) => {
      state.objTags = action.payload
    }
  }
})
export const { setRects, setTechTags, setObjTags } = setSelectedRectsSlice.actions
export default setSelectedRectsSlice.reducer
